import { IDynamicSubmitFieldProps } from "@view/common/DynamicForm/DynamicFormContracts";
import styles from "./OtpSlide.module.css";
import Button from "@view/common/Components/Button";

export interface ILoginSubmitFieldWithBackProps extends IDynamicSubmitFieldProps {
  onResend: () => void;
  loading: boolean;
  loadingOtp: boolean;
}

const LoginOtpSumbit = (props: ILoginSubmitFieldWithBackProps) => {
  return (
    <div className={styles.loginSubmitRoot}>
      <Button
        className={styles.submitButton}
        variant="primary"
        type="button"
        disabled={props.loading || props.loadingOtp}
        onClick={props.onResend}
        loading={props.loadingOtp}
      >
        Reenviar
      </Button>
      <Button
        className={styles.loginSubmitRoot}
        variant="primary"
        type="button"
        disabled={props.disabled || props.loadingOtp}
        onClick={props.onSubmit}
        loading={props.loading}
      >
        {props.label}
      </Button>
    </div>
  );
};

export default LoginOtpSumbit;
